export var AppTitle = {
    German: 'Track & Trace / Delivery Confirmation Request',
    French: 'Track & Trace / Delivery Confirmation Request',
    Italian: 'Track & Trace / Delivery Confirmation Request',
    English: 'Track & Trace / Delivery Confirmation Request'
};
//# sourceMappingURL=AppTitle.js.map